import { BaseService } from './base-service';
import { lastValueFrom } from 'rxjs';
export class ActivityCategoriesService {
    // ----------------------------------------------------------------------
    // Activity Categories
    // ----------------------------------------------------------------------
    static getActivityCategories(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`activity-categories?filter=${qs}`, pageNumber));
    }
    static saveActivityCategory(dto) {
        return lastValueFrom(BaseService.save(`activity-categories`, dto));
    }
    static deleteActivityCategory(oid) {
        return lastValueFrom(BaseService.delete(`activity-categories/${oid}`));
    }
    static searchActivityCategoryCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`activity-categories-combo/${selfId}?search=${qs}`));
    }
}
